import React from "react";
import ArtistContacts from "../components/ArtistContacts";

const ArtistContactsApp = (props) => <ArtistContacts {...props} />;

export default ArtistContactsApp;
